import Action from '@sharedComponents/Action';

import * as style from './style.module.css';

const SegmentedControl = ({ options = [], value, onChange }) => (
    <div className={style.group}>
        {options.map((o) => (
            <Action
                key={o.value}
                className={`${style.btn} ${value === o.value ? style.active : ''}`}
                action={() => onChange(o.value)}
                role="tab"
            >
                {o.label}
            </Action>
        ))}
    </div>
);

export default SegmentedControl;
